module.exports = __webpack_public_path__ + "static/media/hero-road.9e23b5e1.jpeg";